import helpers from "../common/utils/utils";

class AccessionSubmission {
  constructor(data) {
    this.reviewStatus = data?.review_status || "";
    this.reviewDate = helpers.parseNumericDate(data?.review_date);
    this.submitterName = data?.submitter_name || "";
    this.significanceArr = data?.clinical_significance || [];
    this.origin = data?.origin || "";
    this.method = data?.method || "";

    this.diseaseItems = (data?.diseases || [])
      .map((x) => x.symbols || [])
      .filter(Boolean)
      .reduce((a, i) => a.concat(i), [])
      .filter(Boolean)
      .map((x) => Object.entries(x))
      .map((x) => x.map((y) => ({ databaseName: y[0], id: y[1] })))
      .reduce((a, i) => a.concat(i), [])
      .map((x) => ({ ...x, databaseName: x.databaseName.toLowerCase() }))
      .filter(Boolean);

    this.findings = (data?.finding || [])
      .map((x) => x.names || [])
      .reduce((a, i) => a.concat(i), []);
  }
}

export default AccessionSubmission;
